import { v4 as uuidv4 } from 'uuid';
import { getSubscriptionsAPI } from './api';
import { buildSubscriptionMaps } from './getSubscriptions';
import refreshProfileCollections from './refreshProfileCollections';

// Fetches page 1 in isolation (never this.page) so Load More's position isn't disturbed.
async function mergeLatestSubscription() {
    const session = this.env.session;
    const traceId = this.env.traceId;

    const res = await getSubscriptionsAPI({
        store: this,
        token: session.token,
        traceId,
        page: { number: 1, limit: this.page.limit },
    });

    if (res.error) return;

    const results = res?.data?.data?.results;
    if (!Array.isArray(results) || !results.length) return;

    const knownIds = new Set([...this.subscriptions, ...this.inactiveSubscriptions].map((s) => s.id));
    const newItems = results.filter((item) => !knownIds.has(item.id));
    if (!newItems.length) return;

    const newActive = newItems.filter((item) => item.isActive);
    const newInactive = newItems.filter((item) => !item.isActive);

    this.subscriptions = [...newActive, ...this.subscriptions];
    this.inactiveSubscriptions = [...newInactive, ...this.inactiveSubscriptions];

    const { connectedSchedules, subscriptionDetails } = buildSubscriptionMaps(newItems);
    this.connectedSchedules = { ...this.connectedSchedules, ...connectedSchedules };
    this.subscriptionDetails = { ...this.subscriptionDetails, ...subscriptionDetails };

    // totalRecords/totalPages/totalLoaded all derived from actual state, not manual increments.
    this.pageInfo = {
        ...this.pageInfo,
        totalRecords: res.data.data.totalRecords,
        totalPages: res.data.data.totalPages,
        totalLoaded: this.subscriptions.length + this.inactiveSubscriptions.length,
    };

    refreshProfileCollections(this.subscriptions);

    this.observed.subscriptions = uuidv4();
}

export default mergeLatestSubscription;
